import { api } from '../client';
import type { IsoDateTime, Page, PageQuery, Uuid } from '../types';

export type NotificationCategory =
  | 'job_update'
  | 'invitation'
  | 'billing_alert'
  | 'system_announcement';

export interface Notification {
  id: Uuid;
  user_id: Uuid;
  category: NotificationCategory;
  title: string;
  body?: string | null;
  link?: string | null;
  read_at?: IsoDateTime | null;
  created_at: IsoDateTime;
  metadata?: Record<string, unknown>;
}

export interface NotificationListQuery extends PageQuery {
  category?: NotificationCategory;
  unread_only?: boolean;
}

export interface NotificationPreferences {
  email: Record<NotificationCategory, boolean>;
  in_app: Record<NotificationCategory, boolean>;
}

export const notificationsApi = {
  list: (query?: NotificationListQuery) =>
    api.get<Page<Notification>>('/notifications', { params: query }),

  markRead: (id: Uuid) => api.patch<Notification>(`/notifications/${id}/read`),

  markAllRead: () => api.post<void>('/notifications/read-all'),

  preferences: () =>
    api.get<NotificationPreferences>('/notifications/preferences'),

  updatePreferences: (body: NotificationPreferences) =>
    api.put<NotificationPreferences>('/notifications/preferences', body),

  /** SSE endpoint URL — open with `EventSource(url)`. */
  streamUrl: () => '/api/v1/notifications/stream',
};
